module.exports = __webpack_public_path__ + "static/img/test.a158061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/active/test.png
// module id = tTUY
// module chunks = 26